import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "style", "size", "bgColor", "label", "icon", "src", "srcSet", "imageAlt", "mask", "tabIndex", "role", "disabled", "onClick", "children", "ariaLabel", "compact"];
import * as React from 'react';
import { useEffect } from 'react';
import { KEY_VALUES, mergeRefs } from '../utils';
import classNames from 'classnames';
var Avatar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    style = props.style,
    _props$size = props.size,
    size = _props$size === void 0 ? 40 : _props$size,
    bgColor = props.bgColor,
    label = props.label,
    icon = props.icon,
    src = props.src,
    srcSet = props.srcSet,
    imageAlt = props.imageAlt,
    mask = props.mask,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    _props$role = props.role,
    role = _props$role === void 0 ? '' : _props$role,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? true : _props$disabled,
    onClick = props.onClick,
    children = props.children,
    ariaLabel = props.ariaLabel,
    _props$compact = props.compact,
    compact = _props$compact === void 0 ? false : _props$compact,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (compact) {
    size = 32;
  }
  var _React$useState = React.useState(true),
    keyboardFocus = _React$useState[0],
    setKeyboardFocus = _React$useState[1];
  var avatarRef = React.useRef(null);
  useEffect(function () {
    var eventHandler = function eventHandler(event) {
      var keycode = event.which;
      if (keycode === 9 && avatarRef.current) {
        avatarRef.current.classList.add('keyboard-focus');
      }
    };
    var eventClickHandler = function eventClickHandler(event) {
      if (avatarRef.current) {
        avatarRef.current.classList.remove('keyboard-focus');
      }
    };
    window.addEventListener('keydown', eventHandler);
    window.addEventListener('click', eventClickHandler);
    return function () {
      window.removeEventListener('keydown', eventHandler);
      window.removeEventListener('click', eventClickHandler);
    };
  });
  var handleImgLoadError = function handleImgLoadError() {
    var onError = props.onError;
    var errorFlag = onError ? onError() : undefined;
    if (errorFlag !== false) {
      // setIsImgExist(false);
    }
  };
  var avatarClassName = classNames('ap-avatar', className, {
    'mask': mask,
    'disabled': disabled,
    'keyboard-focus': keyboardFocus
  });
  var avatarTextClassName = classNames('ap-avatar-text', {
    'compact': compact
  });
  var childrenToRender = children;
  if (src || srcSet) {
    childrenToRender = /*#__PURE__*/React.createElement("img", {
      src: src,
      onError: handleImgLoadError,
      alt: imageAlt || 'avatar'
    });
  } else if (icon) {
    childrenToRender = icon;
  } else {
    childrenToRender = /*#__PURE__*/React.createElement("span", {
      className: avatarTextClassName
    }, label);
  }
  var avatarStyle = typeof size === 'number' ? {
    width: size,
    height: size,
    lineHeight: size + "px"
  } : {};
  avatarStyle = _extends({
    backgroundColor: bgColor
  }, avatarStyle);
  var handleClick = function handleClick(e) {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  var handleMouseDown = function handleMouseDown(event) {
    setKeyboardFocus(false);
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === KEY_VALUES.TAB) {
      setKeyboardFocus(true);
    }
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: mergeRefs(ref, avatarRef),
    role: role,
    className: avatarClassName,
    style: _extends({}, avatarStyle, style),
    "aria-label": ariaLabel || label,
    tabIndex: disabled ? undefined : tabIndex,
    onClick: disabled ? undefined : handleClick,
    onKeyDown: disabled ? undefined : handleKeyDown,
    onMouseDown: disabled ? undefined : handleMouseDown
  }, rest), childrenToRender);
});
Avatar.displayName = 'Avatar';
export default Avatar;